import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultData, getDefaultUI } from "components/pages/OneTimeACHPaymentPage";
import Classes, { ACHFromAccount, ACHToParticipant, Account, ACHBatch } from "model";

export default function CaptureParticipantsAdded(props) {
    const context = useBCMSContext();

    BCMSRecord.globalControllerFor(Classes, context);

    const effectiveDate = BCMSDate.init().nextBusinessDay().nextBusinessDay();
    const addedAccount = ACHFromAccount.init({ account: "6", id: ACHFromAccount.nextID(), amount: "5000.00" });
    const defaultData = getDefaultData();
    const secCode = ACHBatch.getSelectedSecCodeByBranding();

    const { state } = context ?? {};
    const { branding } = state ?? {};
    const { options } = branding ?? {};
    const hasACHCCDNonConsumerCredit = options.nonconsumer_credit_abi22 === "true";

    let achToParticipants = defaultData.achToParticipants.participants;
    let nextID = undefined;
    if(achToParticipants.length === 0) {
        // check ids globally
        nextID = ACHToParticipant.nextID();
    } else {
        nextID = achToParticipants.length;
    }

    const participants = defaultData.participants.reduce((acc, item, i) => {
        item.isSelected = "true";
        acc.push(item);
        return acc;
    }, []);

    const updatedACHToParticipants = participants.reduce((acc, item) => {
        if(item.isSelected === "true") {
            const added = ACHToParticipant.init({ id: nextID, participant: item.id,
                 oneTimeACHPayment: defaultData.oneTimeACHPayment, notify: "No", addenda: "0" });
            nextID = parseFloat(nextID) + 1;
            acc.push(added);
        }
        return acc;
    }, []);
    achToParticipants = [ ...updatedACHToParticipants, ...achToParticipants ];
    
    let data = BCMSStateManagerCRUD.init(defaultData)
    .update([ "oneTimeACHPayment", "transactionType" ], "payment")
    .update([ "oneTimeACHPayment", "secCode" ], secCode)
    .update([ "oneTimeACHPayment", "scheduleType" ], "future dated")
    .update([ "oneTimeACHPayment", "effectiveDate" ], effectiveDate)
    .update([ "oneTimeACHPayment", "companyEntryDescription" ], hasACHCCDNonConsumerCredit ? "ACH PMT" : "PAYROLL")
    .update([ "oneTimeACHPayment", "company" ], "0")
    .update([ "achFromAccounts", "accounts" ], [ addedAccount ])
    .update([ "participants" ], participants)
    .update([ "achToParticipants", "participants" ], updatedACHToParticipants);

    if(options.offset_account_ui_abi22 === "Single Account") {
        data.update([ "selectedOffsetAccount", "account" ], Account.initByID("6"))
    }

    data = data.submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showOneTimeACHModal", "isActive" ], false)
    .update([ "showSecCode", "isActive" ], true)
    .submit();

    return <OneTimeACHPaymentPage data={ data } ui={ ui } />;
}